import styled from 'styled-components'

export const Field = styled.div`
  width: 16rem;

  & > label {
    height: 2rem;
  }

  & > input, select {
    height: 2.5rem;
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.4rem;
  margin-bottom: 1rem;
`

export const Submit = styled.input`
  margin-top: 2rem;
  width: 16rem;
  height: 2.5rem;
  &:hover {
    transition: 200ms ease-in-out;
    background-color: #2dca98;
  }
`
